export function extractUserType(userObject) {
  return userObject?.attributes?.profile?.publicData?.userType ?? null;
}
